<template>
  <v-dialog
    v-model="interestedDialog"
    max-width="800"
    persistent
  >
    <v-btn
      slot="activator"
      small
      flat
      color="blue"
    >
      Alterar
    </v-btn>
    <v-card>
      <v-card-title class="headline grey lighten-4">
        <v-icon class="mr-2">mdi-account-multiple-plus</v-icon>
        Interessados
      </v-card-title>

      <interested-list />

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          flat
          @click="interestedDialog = false"
        >
          Fechar
        </v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import format from 'date-fns/format';
import bus from '@/utils/event-bus';
import { pt } from 'date-fns/locale/pt';
import InterestedList from '@/components/folder/interested/edit/InterestedList';

export default {
  name: 'InterestedDialog',
  components: {
    InterestedList,
  },
  data() {
    return {
      interestedDialog: false,
    };
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    folderId() {
      return this.$store.getters.activeFolder.id;
    },
    interestedsList() {
      const citizens = this.folder.interesteds_citizens;
      const users = this.folder.interesteds_users;
      return [...citizens, ...users];
    },
  },
  methods: {
    formatDateTime(dateTime) {
      const date = format(dateTime, 'DD/MM/YYYY', { locale: pt });
      const time = format(dateTime, 'HH:mm', { locale: pt });
      return `${date} às ${time}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/folder/interested/edit/InterestedDialog.vue